<template>
  <div class="pwc-self-center">
    <div class="pwc-self-head">
      <pwc-avatar class="pwc-avatar" :avatar="home.userInfo.profilePhotoUrl" :upload="uploadAvatar" />
      <span
        class="pwc-name"
        @click="handleGoTo('edit:info')"
      >{{ home.userInfo.name }}</span>
    </div>

    <van-cell-group class="pwc-self-info">
      <van-cell title="个人资料" is-link @click="handleGoTo('edit:info')" />
    </van-cell-group>
    <van-cell-group class="pwc-self-info">
      <van-cell title="我的优惠券" is-link @click="handleGoTo('go:coupon')" />
    </van-cell-group>
    <van-cell-group class="pwc-self-checkin">
      <van-cell title="我的签到二维码" is-link @click="handleGoTo('go:qrcode')" />
    </van-cell-group>

    <van-cell-group class="pwc-self-event">
      <van-cell title="待参加" is-link @click="handleGoTo('go:approved')" />
      <van-cell title="已注册" is-link @click="handleGoTo('go:registered')" />
    </van-cell-group>

    <van-cell-group class="pwc-self-logout">
      <van-cell title="退出登录" @click="handleGoTo('go:logout')" />
    </van-cell-group>

  </div>
</template>

<script>
/**
 * - edit:info
 * - go:qrcode
 * - go:registered
 * - go:approved
 * - go:logout
 */
import PwcAvatar from '@/components/PwcAvatar'
import { Cell, CellGroup } from 'vant'

export default {
  inject: ['home'],
  components: {
    VanCell: Cell,
    VanCellGroup: CellGroup,
    //
    PwcAvatar
  },
  props: {
    uploadAvatar: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    handleGoTo(e) {
      this.$emit(e)
    }
  }
}
</script>

<style lang="scss">
.pwc-self-center {
  .pwc-self-head {
    height: 36vh;
    background-color: #FFB600;
    // background: url('../../../assets/back.svg') no-repeat;
    background-size: cover;
    text-align: center;
    padding-top: 10vh;
    .pwc-avatar {
      height:100px;
      width: 100px;
      margin: auto;
      margin-bottom: 10px;
      box-shadow: none;
    }
    .pwc-name {
      font-weight: bold;
      display: block;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      -webkit-font-smoothing: antialiased;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }
  .pwc-self-info {
    margin-bottom: 6px;
  }
  .pwc-self-event {
    margin-top: 6px;
  }
  .pwc-self-logout {
    margin-top: 6px;
    >div {
      >div {
        text-align: center;
      }
    }
  }
  .pwc-self-basic {
    margin-top: 6px;
  }
}
</style>

